import React from 'react';
import Icon from '../../../components/AppIcon';

const BillTracker = ({ bills }) => {
  const getDaysUntilDue = (dueDate) => {
    const today = new Date('2026-01-18');
    const due = new Date(dueDate);
    const diffTime = due - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const getDueDateColor = (daysUntil) => {
    if (daysUntil <= 3) return 'text-error';
    if (daysUntil <= 7) return 'text-warning';
    return 'text-muted-foreground';
  };

  return (
    <div className="card h-full">
      <div className="card-header">
        <div>
          <h2 className="card-title">Upcoming Bills</h2>
          <p className="card-description">{bills?.length} bills scheduled</p>
        </div>
      </div>

      <div className="card-content">
        <div className="space-y-3">
          {bills?.map((bill) => {
            const daysUntil = getDaysUntilDue(bill?.dueDate);
            return (
              <div 
                key={bill?.id}
                className="p-4 bg-muted/30 hover:bg-muted/50 rounded-lg transition-smooth"
              >
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <Icon name={bill?.icon} size={20} className="text-primary" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between mb-1">
                      <p className="text-sm font-semibold text-foreground">{bill?.name}</p>
                      {bill?.autoPay && (
                        <div className="flex items-center gap-1 px-2 py-0.5 bg-success/10 rounded-full">
                          <Icon name="CheckCircle" size={12} className="text-success" />
                          <span className="text-xs font-medium text-success">Auto</span>
                        </div>
                      )}
                    </div>
                    <p className="text-lg font-bold text-foreground mb-1">${bill?.amount?.toFixed(2)}</p>
                    <div className="flex items-center gap-2 text-xs">
                      <span className={getDueDateColor(daysUntil)}>
                        Due in {daysUntil} {daysUntil === 1 ? 'day' : 'days'}
                      </span>
                      <span className="text-muted-foreground">•</span>
                      <span className="text-muted-foreground">{bill?.dueDate}</span>
                    </div>
                  </div>
                </div>

                {!bill?.autoPay && (
                  <div className="mt-3 pt-3 border-t border-border">
                    <button className="w-full px-3 py-2 bg-primary/10 hover:bg-primary/20 text-primary rounded-lg text-xs font-medium transition-smooth flex items-center justify-center gap-2">
                      <Icon name="Zap" size={14} />
                      Enable Auto-Pay
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-6 pt-6 border-t border-border">
          <button className="w-full px-4 py-2.5 bg-muted/50 hover:bg-muted text-foreground rounded-lg text-sm font-medium transition-smooth flex items-center justify-center gap-2">
            <Icon name="Plus" size={16} />
            Add Bill
          </button>
        </div>
      </div>
    </div>
  );
};

export default BillTracker;